import {Injectable} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse, HttpResponse,
} from '@angular/common/http';
import {MatDialog} from "@angular/material/dialog";
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

import {InfoService} from '../../info.service';
import {SecurityService} from "../../security/services/security.service";
import {ErrorCodeEnum as ErrorCode} from "../enums/error-code.enum";
import {AuthService} from '../services/auth.service';
import {SnackbarService} from "../services/snackbar.service";

/**
 * This file is for RequestInfoInterceptor 
 * 
 * author u1100081
 * 
 * Version History :
 *   Date              Name             Reason for modification
 * 21-Apr-2026     Naresh Ginjupalli        IVPSD-8018
 */

@Injectable()
export class RequestInfoInterceptor implements HttpInterceptor {
  constructor(
    private infoService: InfoService,
    private router: Router,
    private authService: AuthService,
    private securityService: SecurityService,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,

  ) {}

  /**
   * Normalize API `code` to a string key for ErrorCodeEnum lookup (string or `{ name: "SD_0406" }`).
   */
  private static normalizeErrorCode(raw: unknown): string | undefined {
    if (raw == null) {
      return undefined;
    }
    if (typeof raw === 'string') {
      const trimmed = raw.trim();
      return trimmed.length ? trimmed : undefined;
    }
    if (typeof raw === 'object' && 'name' in (raw as object)) {
      const name = (raw as { name?: unknown }).name;
      if (typeof name === 'string') {
        const trimmed = name.trim();
        return trimmed.length ? trimmed : undefined;
      }
    }
    return undefined;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        // if (event instanceof HttpResponse) {
        //   if (!request.url.includes('/me') && !request.url.includes('/auth')) {
        //     this.infoService.getInfo().toPromise();
        //   }
        // }
        if (event instanceof HttpResponse) {
          if(this.authService.isLoggedIn() && !request.url.includes('/logout')) {
            if(this.securityService.securityConfig) {
              this.securityService.resetCount();
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 410 || error.status === 401) {
          this.authService.isAdminModule(this.router.url) ? this.router.navigate(['/admin/signin']) :
          this.router.navigate(['/signin']);
          this.dialog.closeAll();
          this.authService.removeAuthorizedFlag();
        }
        const codeKey = RequestInfoInterceptor.normalizeErrorCode(error.error?.code);
        if (codeKey) {
          const catalogEntry = ErrorCode[codeKey as keyof typeof ErrorCode];
          const catalog =
            typeof catalogEntry === 'string' ? catalogEntry : undefined;
          const msg =
            catalog ||
            error.error.developerMessage ||
            (typeof error.error.message === 'string' ? error.error.message : undefined);
          if (msg) {
            this.snackbarService.showError(msg);
          }
        }
        return throwError(error);
      })
    );
  }
}
